import { GeneralInfo } from './../../VIewModels/TowLocateViewModels/GeneralInfo';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MultipleResultServiceService {
  private messageSource = new BehaviorSubject( new Array<GeneralInfo>());
  currentMessage = this.messageSource.asObservable();

  constructor() { }

  changeMessage(message:Array<GeneralInfo>)
{
  this.messageSource.next(message);
}

}



// WEBPACK FOOTER //
// ./src/app/Services/TowLocateServices/multiple-result-service.service.ts